import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminProductSolutionGroups = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_GROUPS.GET_ALL, { params });
    return response.data;
};

export const getAdminProductSolutionGroupById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_GROUPS.GET_BY_ID(id));
    return response.data;
};

export const createProductSolutionGroup = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_GROUPS.CREATE, data);
    return response.data;
};

export const updateProductSolutionGroup = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_GROUPS.UPDATE(id), data);
    return response.data;
};

export const deleteProductSolutionGroup = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_GROUPS.DELETE(id));
    return response.data;
};
